import "./demoMotion.css";
import "./demoThemes.css";
import "./demoComplete.css";
import { DemoFullFooter, DemoContactBlock } from "./DemoFullParts";

const CHAPTERS = [
  { num: "01", title: "Mission", sub: "왜 시작했는가", desc: "복잡한 기술을 비즈니스 언어로 번역해, 누구나 이해할 수 있는 솔루션을 만듭니다.", grad: "linear-gradient(145deg,#ede9fe,#ddd6fe)" },
  { num: "02", title: "Approach", sub: "어떻게 다른가", desc: "기획·디자인·개발을 한 팀에서 진행해 일정과 품질을 동시에 관리합니다.", grad: "linear-gradient(145deg,#fce7f3,#fbcfe8)" },
  { num: "03", title: "Proof", sub: "왜 믿을 수 있는가", desc: "120+ 프로젝트, 98% 재의뢰율. 숫자와 사례로 신뢰를 증명합니다.", grad: "linear-gradient(145deg,#e0e7ff,#c7d2fe)" },
];

const TEAM = [
  { name: "이서연", role: "CEO · Strategy", init: "이" },
  { name: "김도현", role: "Design Director", init: "김" },
  { name: "박지원", role: "Tech Lead", init: "박" },
];

export default function BrandStorytellingDemo({ embed = false }) {
  return (
    <div
      className={`demo-root demo-meri${embed ? " demo-root--embed" : ""}`}
      data-testid="portfolio-demo-brand-storytelling"
      style={{
        "--accent": "#7c3aed",
        "--bg": "#faf8f5",
        "--muted": "#78716c",
        "--border": "#e7e5e4",
        "--card": "#ffffff",
        "--section-alt": "#f5f3ef",
      }}
    >
      <header className="demo-meri__nav">
        <h1>Meridian Labs</h1>
        <nav className="demo-full__nav-links" style={{ color: "#78716c" }}>
          <span>Story</span>
          <span>Services</span>
          <span>Team</span>
          <span>Contact</span>
        </nav>
        <span style={{ fontSize: "0.72rem", letterSpacing: "0.1em", textTransform: "uppercase", padding: "0.45rem 0.9rem", border: "1px solid #e7e5e4", whiteSpace: "nowrap" }}>Partnership</span>
      </header>

      <section className="demo-meri__cover">
        <div style={{ position: "relative", maxWidth: 600 }}>
          <p style={{ margin: "0 0 0.75rem", fontSize: "0.72rem", letterSpacing: "0.14em", textTransform: "uppercase", opacity: 0.8 }}>Digital Transformation Partner · Since 2018</p>
          <h2>기술로 문제를 풀고, 사람에게 남는 가치를 만듭니다</h2>
        </div>
      </section>

      <section style={{ padding: "3rem 1.5rem", maxWidth: 680, margin: "0 auto", textAlign: "center" }}>
        <p style={{ margin: 0, fontFamily: "Georgia, serif", fontSize: "1.15rem", lineHeight: 1.8, color: "#57534e" }}>
          Meridian Labs는 B2B 디지털 전환 파트너입니다.
          브랜드 철학·서비스·실적을 스토리로 연결해, 첫 방문에서 신뢰와 기억을 남깁니다.
        </p>
      </section>

      <section className="demo-full__section demo-full__section--alt" style={{ background: "#f5f3ef" }}>
        <div className="demo-full__wrap">
          <div className="demo-full__head">
            <span className="demo-full__eyebrow">Our Story</span>
            <h2 style={{ color: "#1c1917", fontFamily: "Georgia, serif", fontWeight: 400 }}>세 가지 이야기</h2>
          </div>
          <div className="demo-meri__chapters" style={{ justifyContent: "center", flexWrap: "wrap" }}>
            {CHAPTERS.map((ch) => (
              <article key={ch.num} className="demo-meri__chapter" style={{ flex: "0 0 280px" }}>
                <div className="demo-meri__chapter-img" style={{ background: ch.grad }} />
                <div className="demo-meri__chapter-body">
                  <em>Chapter {ch.num} · {ch.title}</em>
                  <h3>{ch.sub}</h3>
                  <p>{ch.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-full__head">
            <h2 style={{ color: "#1c1917", fontFamily: "Georgia, serif", fontWeight: 400 }}>서비스 영역</h2>
          </div>
          <div className="demo-full__grid3">
            {[
              { t: "브랜드 전략", d: "미션·비전·핵심 가치를 시각적으로 일관되게 전달합니다." },
              { t: "스토리텔링 UX", d: "스크롤마다 몰입감 있는 내러티브를 설계합니다." },
              { t: "신뢰 구축", d: "고객사·실적·수상을 데이터로 보여 신뢰를 강화합니다." },
            ].map((s) => (
              <article key={s.t} className="demo-full__card" style={{ background: "#fff" }}>
                <h3 style={{ color: "#1c1917", fontFamily: "Georgia, serif", fontWeight: 400, fontSize: "1.1rem" }}>{s.t}</h3>
                <p style={{ color: "#78716c" }}>{s.d}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <div className="demo-meri__metrics">
        <div className="demo-meri__metric"><strong>2018</strong><span>설립</span></div>
        <div className="demo-meri__metric"><strong>120+</strong><span>프로젝트</span></div>
        <div className="demo-meri__metric"><strong>98%</strong><span>재의뢰율</span></div>
      </div>

      <blockquote className="demo-meri__quote">
        "회사 소개가 단순 나열이 아니라, 왜 이 팀과 일해야 하는지가 스크롤하면서 자연스럽게 전달됩니다."
        <footer style={{ marginTop: "1rem", fontStyle: "normal", fontSize: "0.8rem", color: "#78716c" }}>— 최윤아, BD 팀장 · IT 기업</footer>
      </blockquote>

      <section className="demo-full__section">
        <div className="demo-full__wrap">
          <div className="demo-full__head">
            <h2 style={{ color: "#1c1917", fontFamily: "Georgia, serif", fontWeight: 400 }}>Leadership</h2>
          </div>
          <div className="demo-full__grid3">
            {TEAM.map((m) => (
              <div key={m.name} className="demo-full__card" style={{ background: "#fff", textAlign: "center" }}>
                <span className="demo-full__avatar" style={{ margin: "0 auto 0.75rem", width: 56, height: 56, fontSize: "1rem", background: "linear-gradient(135deg,#7c3aed,#a78bfa)" }}>{m.init}</span>
                <h3 style={{ margin: 0, color: "#1c1917", fontFamily: "Georgia, serif", fontWeight: 400 }}>{m.name}</h3>
                <p style={{ margin: "0.25rem 0 0", color: "#78716c", fontSize: "0.78rem" }}>{m.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="demo-full__marquee" style={{ background: "#fff" }}>
        <div className="demo-full__marquee-track" style={{ color: "#d6d3d1" }}>
          {["Hyundai Glovis", "Line Plus", "Woowa Bros", "Kakao Ventures", "NHN", "Hyundai Glovis", "Line Plus"].map((n, i) => (
            <span key={`${n}-${i}`}>{n}</span>
          ))}
        </div>
      </div>

      <DemoContactBlock
        title="파트너십 미팅 요청"
        sub="브랜드 스토리에 맞는 홈페이지 컨셉을 3영업일 내 제안해 드립니다."
        fields={["회사명", "담당자", "이메일", "프로젝트 개요"]}
        btnLabel="미팅 요청하기"
      />

      <DemoFullFooter
        brand="Meridian Labs"
        desc="B2B 디지털 전환 파트너 · Seoul, Korea"
        columns={[
          { title: "Company", links: ["About", "Team", "Careers", "News"] },
          { title: "Work", links: ["Services", "Case Studies", "Insights"] },
          { title: "Contact", links: ["hello@meridianlabs.com", "LinkedIn", "Seoul"] },
        ]}
        copy="© 2026 Meridian Labs. Crafted with intention."
      />
    </div>
  );
}
